import VcardsApi from '@/api/vcards'

let fetchPromise: Promise<any> | null = null

export default {
  namespaced: true,
  state: {
    templates: [],
    loadingTemplates: false,
    templatesLoaded: false,
  },
  getters: {
    templates: (state: any) => state.templates ?? [],
    loadingTemplates: (state: any) => state.loadingTemplates,
    templatesLoaded: (state: any) => state.templatesLoaded,
  },
  mutations: {
    SET_TEMPLATES(state: any, templates: Array<any>) {
      state.templates = templates
      state.templatesLoaded = true
    },
    SET_LOADING_TEMPLATES(state: any, loading: boolean) {
      state.loadingTemplates = loading
    },
  },
  actions: {
    async FETCH_TEMPLATES(context: any) {
      // If templates are already loaded, don't fetch again
      if (context.state.templatesLoaded && context.state.templates.length > 0) {
        return context.state.templates
      }

      // If a fetch is already in progress, return the existing promise
      if (fetchPromise) {
        return fetchPromise
      }

      // Set loading state and create promise atomically
      context.commit('SET_LOADING_TEMPLATES', true)

      // Create and cache the promise immediately (synchronously)
      fetchPromise = (async () => {
        try {
          const result = await VcardsApi.getTemplates()
          if (result.error === 0 && result.data) {
            context.commit('SET_TEMPLATES', result.data)
            return result.data
          }
          return []
        } catch (error) {
          console.error('Failed to load templates:', error)
          return []
        } finally {
          context.commit('SET_LOADING_TEMPLATES', false)
          fetchPromise = null // Clear the promise cache
        }
      })()

      return fetchPromise
    },
  },
}
